import { getImages } from "../apiPayloadGeneratingFunctions/getImages";


export const handleStep = async (
  images,
  category,
  postmortemState,
  incidentID,
  setImagesSavedSuccessfully,
  postImage
) => {
  if (Object.values(images).some((image) => image.length > 0)) {
    let apiCalls = [];

    for (let [key, value] of Object.entries(images)) {
      if (value.length > 0) {
        const { tags, combinedFormData } = getImages(
          key,
          value,
          postmortemState.imageFormData[key],
          incidentID
        );

        apiCalls.push(postImage(combinedFormData, tags, incidentID));
      }
    }

    const results = await Promise.allSettled(apiCalls);
    const failed = results.filter((result) => result.status === "rejected");

    if (failed.length > 0) {
      throw new Error("Some images failed to send");
    } else {
      setImagesSavedSuccessfully(true);
    }
  } else {
    setImagesSavedSuccessfully(true);
  }
};
